// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1JuW5","bigColWidth":"Table_bigColWidth__3Ki3U","biggerColWidth":"Table_biggerColWidth___D_Ax","row":"Table_row__2_MlR","col":"Table_col__oBkZB"};